// extracted by mini-css-extract-plugin
export var headerXL = "SimilarENs-module--headerXL--1TvhW";
export var headerL = "SimilarENs-module--headerL--av_v1";
export var headerM = "SimilarENs-module--headerM--1o7q1";
export var headerS = "SimilarENs-module--headerS--1YVyQ";
export var headerXS = "SimilarENs-module--headerXS--1I2_d";
export var blogHeaderXL = "SimilarENs-module--blogHeaderXL--3v2sd";
export var blogHeaderL = "SimilarENs-module--blogHeaderL--2QE4w";
export var blogHeaderM = "SimilarENs-module--blogHeaderM--uv1Fj";
export var blogHeaderS = "SimilarENs-module--blogHeaderS--30Drt";
export var blogHeaderXS = "SimilarENs-module--blogHeaderXS--32jSl";
export var headerPreamble = "SimilarENs-module--headerPreamble--1osb5";
export var preHeader = "SimilarENs-module--preHeader--28eEV";
export var textNormal = "SimilarENs-module--textNormal--3EMO9";
export var textSmall = "SimilarENs-module--textSmall--2vvVu";
export var textSmallAlternate = "SimilarENs-module--textSmallAlternate--1Y6jm";
export var legend = "SimilarENs-module--legend--31M0m";
export var caption = "SimilarENs-module--caption--1941q";
export var gradientBackground = "SimilarENs-module--gradientBackground--3305N";
export var ellipsis = "SimilarENs-module--ellipsis--3346J";
export var globalContainer = "SimilarENs-module--globalContainer--3v9X7";
export var maxWidth = "SimilarENs-module--maxWidth--3deNN";
export var clipBottom = "SimilarENs-module--clipBottom--1D2eF";
export var clipTopBottom = "SimilarENs-module--clipTopBottom--1rksd";
export var similarNetworks = "SimilarENs-module--similarNetworks--1MGEb";
export var container = "SimilarENs-module--container--2vzI-";
export var label = "SimilarENs-module--label--1HeZw";
export var content = "SimilarENs-module--content--3SRlX";
export var thumbnail = "SimilarENs-module--thumbnail--3nhJZ";
export var ch2 = "SimilarENs-module--ch2--A9RvX";
export var ch2Container = "SimilarENs-module--ch2-container--1YDWK";